import React, { useState, useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import SEO from "../components/seo"
import Layout from "../components/layout"
import HeroFeaturedArticle from "../components/organisms/HeroFeaturedArticle"
import ArticlesListing from "../components/organisms/ArticlesListing"
import ContactUs from "../components/organisms/ContactUs"
import LearnMore from "../components/organisms/LearnMore"

const query = graphql`
  {
    allStrapiCategories {
      edges {
        node {
          Title
          id
          strapiId
        }
      }
    }
    strapiBlog {
      addOverlayOnHero
      contactUs {
        title {
          subtitle
          title
        }
        buttons {
          title
        }
      }
      heroArticle {
        title
        articleCustomUrl
        fullWidthImage {
          childImageSharp {
            fluid(maxWidth: 3840, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
        category
        excerpt
        timeToRead
        created_at
      }
      beforeFooter {
        button {
          title
        }
        text
      }
      metaTags {
        description
        ogImage {
          childImageSharp {
            fluid(maxWidth: 1200, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        title
      }
    }
    allStrapiArticles(filter: {public: {eq: true}}) {
      edges {
        node {
          category {
            id
            Title
          }
          created_at
          id
          title
          excerpt
          timeToRead
          articleCustomUrl
          image {
            childImageSharp {
              fluid(maxWidth: 1920, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  }
`

const BlogPage = () => {
  const data = useStaticQuery(query)
  const blog = data.strapiBlog
  const addOverlayOnHero = blog.addOverlayOnHero
  const learnMoreData = blog.beforeFooter
  const contactUsData = blog.contactUs
  const seo = data.strapiBlog?.metaTags
  const articles = data?.allStrapiArticles?.edges.filter(
    ({ node }) =>
      node.title !== "Test" &&
      node.title !== "draft test" &&
      node.title !==
        "Background video loops — does it fit my website? How to build it?"
  )
  const heroArticle = data?.strapiBlog?.heroArticle
  const categories = data?.allStrapiCategories?.edges
  const [isDesktop, setIsDesktop] = useState(true)

  function checkDevice() {
    if (window.innerWidth > 768) {
      setIsDesktop(true)
    } else {
      setIsDesktop(false)
    }
  }

  function getCategoryByID(id) {
    const cat = categories.find(({ node }) => node.id === `Categories_${id}`)
    return cat ? cat?.node?.Title : ""
  }

  function filterArtclesByDate(articles) {
    return articles.sort((a, b) => {
      const dateA = new Date(a.node.created_at)
      const dateB = new Date(b.node.created_at)
      return dateB - dateA
    })
  }

  useEffect(() => {
    checkDevice()
  }, [])

  useEffect(() => {
    window.addEventListener("resize", checkDevice)
    return () => {
      window.removeEventListener("resize", checkDevice)
    }
  })

  return (
    <Layout className="blog">
      {seo && (
        <SEO
          image={seo?.ogImage?.childImageSharp?.fluid?.src}
          title={seo?.title}
          description={seo?.description}
        />
      )}
      <HeroFeaturedArticle
        title={heroArticle?.title}
        articleCustomUrl={heroArticle?.articleCustomUrl}
        category={getCategoryByID(heroArticle?.category)}
        timeToRead={heroArticle?.timeToRead}
        date={heroArticle?.created_at}
        addOverlayOnHero={addOverlayOnHero}
        imageDesktop={heroArticle?.fullWidthImage?.childImageSharp?.fluid}
      />
      <ArticlesListing
        isDesktop={isDesktop}
        articles={filterArtclesByDate(articles)}
        categories={categories}
      />
      <ContactUs
        contactUsTitle={contactUsData.buttons[0].title}
        title={contactUsData.title.title}
        subtitle={contactUsData.title.subtitle}
      />
      <LearnMore linkTitle={learnMoreData.button.title} to="/about">
        {learnMoreData.text}
      </LearnMore>
    </Layout>
  )
}

export default BlogPage
